import { useCallback, useState } from "react";
import {
  TGetHistoryData,
  TGetHistoryErrorData,
  getChatHistory, TGetSearchErrorData
} from "api";
import axios from "axios";

export const useGetChatHistory = () => {
  const [data, setData] = useState<TGetHistoryData[]>([])
  const [error, setError] = useState<TGetHistoryErrorData | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)


  const getErrorMessage = (code: TGetSearchErrorData['status']) => {
    return `${code}`
  }

  const fetchChatHistory = useCallback(async (conversationId: string) => {
    setData([])
    setError(null)
    setIsLoading(true)

    try {
      const { data } = await getChatHistory(conversationId)
      setData(data)
    } catch (error: unknown) {
      const status = axios.isAxiosError(error) && error.response ? error.response.status : 204
      setError({
        status,
        message: getErrorMessage(status)
      })
    } finally {
      setIsLoading(false)
    }
  }, [])

  const addToChatHistory = (data: TGetHistoryData) => {
    setData(prevState => {
      return [...prevState, data]
    })
  }

  return {
    chatHistoryData: data,
    chatHistoryErrorData: error,
    isChatHistoryLoading: isLoading,
    fetchChatHistory,
    addToChatHistory
  }
}